var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutdoors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40222 19.4568C2.40222 19.771 2.63123 20 2.94542 20H5.34818C5.66237 20 5.89138 19.771 5.89138 19.4568V16.1957H2.40232L2.40222 19.4568Z",
    fill: "#2E84FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9888 19.4568C15.9888 19.771 16.2178 20 16.5036 20H18.9347C19.2205 20 19.4779 19.771 19.4779 19.4568V16.1957H15.9888L15.9888 19.4568Z",
    fill: "#2E84FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.48982 5.21251C4.37531 4.89832 3.91822 4.89832 3.80373 5.21251L0.314668 14.3938C0.143381 14.8518 0.314668 15.1092 0.801082 15.1092H4.06217C3.97606 14.795 3.97606 14.3938 4.11896 14.0218L5.97851 9.10174L4.49088 5.21125L4.48982 5.21251Z",
    fill: "#2E84FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2116 0.235642C11.0971 -0.0785475 10.6401 -0.0785475 10.5256 0.235642L5.14855 14.3937C4.97726 14.8517 5.17694 15.1091 5.63496 15.1091H16.1034C16.5614 15.1091 16.7611 14.8517 16.5898 14.3937L11.2128 0.235642H11.2116Z",
    fill: "#2E84FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.12402 19.4568C9.12402 19.771 9.35304 20 9.63883 20H12.0699C12.3557 20 12.6131 19.771 12.6131 19.4568V16.1957H9.12407L9.12402 19.4568Z",
    fill: "#2E84FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3903 5.2125L15.8175 9.30262L17.5909 14.0219C17.7338 14.3938 17.7622 14.7941 17.6771 15.1092H21.0811C21.5391 15.1092 21.7388 14.8518 21.5675 14.3938L18.0784 5.21255C17.9355 4.89836 17.5068 4.89836 17.3923 5.21255L17.3903 5.2125Z",
    fill: "#2E84FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoors);
export default __webpack_public_path__ + "static/media/outdoors.15b6880d0de6deb5f3861bb86e330440.svg";
export { ForwardRef as ReactComponent };